import React, { FC } from 'react';
import { PortalDialog } from '@component/Portal';
import { Modal } from '@app/react/uikit/Modal';

export interface CartInDialogProps {
    isShow: boolean;
    toNextProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
    toECProps?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
    toCartProps?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
}

export const CartInDialog: FC<CartInDialogProps> = (props) => {
    const {
        isShow = false, toNextProps, toECProps, toCartProps,
    } = props;

    const title = 'カートに追加しました';

    return (
        <PortalDialog className="cart-in-dialog">
            <Modal show={isShow} setShow={() => false}>
                <span className="title">{title}</span>

                <div className="footer">
                    <button type="button" className="next" {...toNextProps}>
                        オーダーメイドを続ける
                    </button>
                    <a className="to-ec" {...toECProps}>
                        消耗品など買い物を続ける
                    </a>
                    <a className="to-cart" {...toCartProps}>
                        カートへ進む →
                    </a>
                </div>
            </Modal>
        </PortalDialog>
    );
};
